// Uploads a file to a presigned URL (S3/GCS-style). Uses plain `fetch` on
// purpose — it must bypass the shared axios client, whose request interceptor
// would JSON-stringify (and destroy) the binary body, force application/json,
// and try to decrypt the storage provider's response.

/** PUT the raw file bytes to a presigned upload URL. Throws on a non-2xx. */
export const uploadToPresignedUrl = async (url: string, file: File): Promise<void> => {
  const res = await fetch(url, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });
  if (!res.ok) throw new Error(`Upload failed (${res.status})`);
};
